import state from './staffListState'
import mutations from './staffListMutations'
import actions from './staffListActions'
import getters from './staffListGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
